var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_368_8526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1637 1.66602H5.83191C3.53115 1.66602 1.66602 3.53115 1.66602 5.83191V14.1637C1.66602 16.4645 3.53115 18.3296 5.83191 18.3296H14.1637C16.4645 18.3296 18.3296 16.4645 18.3296 14.1637V5.83191C18.3296 3.53115 16.4645 1.66602 14.1637 1.66602Z",
    stroke: "#F6339A",
    strokeWidth: 1.66636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3306 9.47277C13.4334 10.1662 13.3149 10.8744 12.9921 11.4966C12.6692 12.1188 12.1584 12.6234 11.5322 12.9385C10.9061 13.2537 10.1965 13.3634 9.50442 13.252C8.81233 13.1406 8.17298 12.8139 7.67731 12.3182C7.18163 11.8225 6.85487 11.1832 6.7435 10.4911C6.63214 9.79901 6.74183 9.08942 7.05699 8.46327C7.37215 7.83712 7.87672 7.32629 8.49894 7.00343C9.12116 6.68057 9.82934 6.56213 10.5227 6.66496C11.2301 6.76984 11.8849 7.09943 12.3905 7.60504C12.8961 8.11065 13.2257 8.76547 13.3306 9.47277Z",
    stroke: "#F6339A",
    strokeWidth: 1.66636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5811 5.41602H14.5894",
    stroke: "#F6339A",
    strokeWidth: 1.66636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_368_8526"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9963,
    height: 19.9963,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram2);
export default __webpack_public_path__ + "static/media/instagram2.d22f5fe85be2f0f8cb420551d10af90e.svg";
export { ForwardRef as ReactComponent };